<template>
  <div
    class="pane-footer pa-6 position-relative row-gap-2 d-flex flex-column"
    data-locator="ai-assistant-footer"
  >
    <template v-if="hasCreditsRemaining">
      <AIAssistantPaneForm
        :cleared="!postPromptStreaming"
        :disabled="postPromptStreaming || postPromptPending"
        @post-prompt="onPostPrompt"
      />
      <AIAssistantRemainingCredits
        :credits="credits"
        :credits-label="`${TRANSLATION_KEY_PREFIX}.remainingCreditsLabel`"
        :credits-pending="creditsPending"
        :credits-threshold-warning="5"
      />
    </template>
    <app-text-divider v-else variant="dashed" color="#5F39AC">
      <div class="remaining-credits-alert d-flex column-gap-3 align-center">
        <app-material-icon
          name="warning"
          color="#7247C9"
          :size="30"
        />
        <p class="text-center text--x-small">
          <span class="text-purple-darken-1 font-weight-bold">{{ $t(`${TRANSLATION_KEY_PREFIX}.remainingCreditsAlertHighlight`) }}</span> <br />
          {{ $t(`${TRANSLATION_KEY_PREFIX}.remainingCreditsAlertMessage`) }}
        </p>
      </div>
    </app-text-divider>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'vuex'

import AIAssistantPaneForm from './AIAssistantPaneForm.vue'
import AIAssistantRemainingCredits from './AIAssistantRemainingCredits.vue'

const TRANSLATION_KEY_PREFIX = 'common.ai-assistant.AIAssistantPaneFooter'

export default defineComponent({
  name: 'AIAssistantPaneFooter',
  components: {
    AIAssistantPaneForm,
    AIAssistantRemainingCredits,
  },
  data() {
    return {
      TRANSLATION_KEY_PREFIX,
    }
  },
  computed: {
    ...mapState('aiAssistant', ['credits', 'creditsPending', 'postPromptPending', 'postPromptStreaming']),
    hasCreditsRemaining(): boolean {
      return this.credits.remaining > 0
    },
  },
  methods: {
    onPostPrompt(prompt: string) {
      this.$emit('post-prompt', prompt)
    },
  },
})
</script>

<style lang="scss" scoped>
.pane-footer {
  .remaining-credits {
    position: absolute;
    bottom: 36px;
    left: 32px;
    color: #2A476A;
  }
  .remaining-credits-alert {
    margin: 0 auto;
    width: fit-content;
    padding: 0 16px;
  }
}
</style>
